import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

// Standardized subscription/access state across the app
// Usage:
//   import useSubscriptionStatus from '@/Composables/useSubscriptionStatus'
//   const { plan, accessStatus, isFree, isPro, isPremium, isRestricted, shouldShowUpgradeOverlay } = useSubscriptionStatus()
export function useSubscriptionStatus() {
  const page = typeof usePage === 'function' ? usePage() : null;

  // Current user plan (fallback to 'free' if missing)
  const plan = computed(() => (page?.props?.auth?.user?.plan ?? 'free'));

  // Centralized access status. Prefer top-level prop, then user field. Default 'granted'.
  const accessStatus = computed(() => (
    page?.props?.accessStatus ?? page?.props?.auth?.user?.access_status ?? ''
  ));

  // Convenience flags
  const isFree = computed(() => plan.value === 'free');
  const isPro = computed(() => plan.value === 'pro');
  const isPremium = computed(() => plan.value === 'premium');

  // Whether dashboard access is restricted (e.g., canceled/expired plan)
  const isRestricted = computed(() => accessStatus.value === 'restricted');

  // Show upgrade overlay for Free users who are not in a restricted state
  return {
    plan,
    accessStatus,
    isFree,
    isPro,
    isPremium,
    isRestricted,
  };
}

export default useSubscriptionStatus;
